export default __webpack_public_path__ + "static/media/2105.798d79b1.png";